export default "__VITE_ASSET__aa5bf390__"